type AppConfig = {
  VITE_CONFIG_API_BASE: string;
  VITE_CONFIG_BASE_URL: string;
  // Multi-tenant: URL/REALM Keycloak non più cablati — l'authority (realm del
  // macro-cliente) è scoperta a runtime via Home Realm Discovery. Tenuti opzionali
  // per compatibilità con config.js che li omette. CLIENT_ID resta (pubblico, costante).
  VITE_CONFIG_KEYCLOAK_URL?: string;
  VITE_CONFIG_KEYCLOAK_REALM?: string;
  VITE_CONFIG_KEYCLOAK_CLIENT_ID: string;
  // Fondo cartografico (src/app/components/map/basemaps.ts). TILES_BASE_URL è la base
  // della mappa self-hostata, sulla stessa origine della web app (`${BASE_URL}/tiles`
  // in esercizio, `/tiles` in sviluppo dietro il proxy di Vite): ogni richiesta sotto
  // di essa porta il Bearer dell'operatore (BasemapLayer). Senza, standard e
  // dettagliata sono le raster pubbliche (Esri World Topo Map, OpenStreetMap).
  VITE_CONFIG_TILES_BASE_URL?: string;
  VITE_CONFIG_SATELLITE_TILES_URL?: string;
  VITE_CONFIG_SATELLITE_ATTRIBUTION?: string;
  [key: string]: string | undefined;
};

declare global {
  interface Window {
    __APP_CONFIG__: AppConfig;
  }
}

export default window.__APP_CONFIG__;
